module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_library.js
// module id = 1135
// module chunks = 0